'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _axwayReactIntl = require('axway-react-intl');

var _axwayReactIntl2 = _interopRequireDefault(_axwayReactIntl);

var _reactBootstrap = require('react-bootstrap');

var _RootCloseWrapper = require('react-overlays/lib/RootCloseWrapper');

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownButton = function (_React$Component) {
	_inherits(DropdownButton, _React$Component);

	function DropdownButton(props) {
		_classCallCheck(this, DropdownButton);

		var _this = _possibleConstructorReturn(this, (DropdownButton.__proto__ || Object.getPrototypeOf(DropdownButton)).call(this, props));

		_axwayReactIntl2.default.init(_this);

		// selectedItems is populated as a unique set of the given prop and the items with 'active'
		_this.state = {
			open: props.open,
			selectedItems: [].concat(_toConsumableArray(new Set(props.selectedItems.concat(_this.getActiveItems()))))
		};
		_this.title = _this.props.title || _this.intl.formatMsg('Select...');
		_this.getButtonText = _this.getButtonText.bind(_this);
		_this.onItemClicked = _this.onItemClicked.bind(_this);
		_this.toggle = _this.toggle.bind(_this);
		_this.getActiveItems = _this.getActiveItems.bind(_this);
		_this.renderItems = _this.renderItems.bind(_this);
		_this.handleRootClose = _this.handleRootClose.bind(_this);
		return _this;
	}

	/* populates the dropdown button's text. The cases are:
 	 1. if title is given, uses that regardless of the selection
 	 2. if title is not given, uses selection. If nothing selected, uses "Select..." */


	_createClass(DropdownButton, [{
		key: 'getButtonText',
		value: function getButtonText() {
			var selectedItems = this.state.selectedItems;
			var _props = this.props,
			    title = _props.title,
			    multiple = _props.multiple;

			var selectedItemsTexts = [];

			// get active item's text
			this.props.children.forEach(function (item) {
				if (selectedItems.indexOf(item.props.eventKey) >= 0) {
					selectedItemsTexts.push(item.props.children);
				}
			});

			if (title && typeof title === 'function') {
				return title(selectedItems);
			} else if (typeof title === 'string') {
				return multiple ? title + ' (' + selectedItems.length + ')' : title;
			} else if (selectedItemsTexts.length) {
				return selectedItemsTexts.join(', ');
			} else {
				return this.title;
			}
		}

		/* handles (de)selection of the items (saving values into the state) */

	}, {
		key: 'onItemClicked',
		value: function onItemClicked(key, e) {
			e.preventDefault();
			e.stopPropagation();
			var selectedItems = this.state.selectedItems;
			var currentItemIndex = selectedItems.indexOf(key);

			if (!selectedItems.length) {
				selectedItems.push(key);
			} else if (currentItemIndex < 0 && this.props.multiple) {
				// if the clicked item is not selected already
				selectedItems.push(key);
			} else if (currentItemIndex < 0 && !this.props.multiple) {
				selectedItems = [key];
			} else if (currentItemIndex >= 0 && this.props.multiple) {
				// if the clicked item is already selected, deselect it.
				selectedItems.splice(currentItemIndex, 1);
			}
			// call the given onSelect returning the complete selectedItems
			if (this.props.onSelect) {
				this.props.onSelect(key, e, selectedItems);
			}

			// set open to true preventing menu closure in multiple mode
			this.setState({
				open: !!this.props.multiple,
				selectedItems: selectedItems
			});
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			this.setState({ open: !this.state.open });
		}
	}, {
		key: 'handleRootClose',
		value: function handleRootClose() {
			this.setState({ open: false });
		}
	}, {
		key: 'getActiveItems',
		value: function getActiveItems() {
			return this.props.children.filter(function (item) {
				return item.props.active;
			}).map(function (i) {
				return i.props.eventKey;
			});
		}

		/* returns an array of children menuitems as per their active states */

	}, {
		key: 'renderItems',
		value: function renderItems() {
			var _this2 = this;

			var selectedItems = this.state.selectedItems;
			var children = this.props.children;

			return children.map(function (item) {
				var _item$props = item.props,
				    eventKey = _item$props.eventKey,
				    title = _item$props.title,
				    key = _item$props.key;

				var text = item.props.children;
				var additionalProps = {};

				// if a child exists in selectedItems, render it active by adding the property
				if (selectedItems.indexOf(eventKey) >= 0) {
					additionalProps.active = true;
				} else {
					additionalProps.active = false;
				}
				additionalProps.title = title || text;
				if (!key) {
					additionalProps.key = eventKey;
				}
				// if space key is pressed, call the onItemClicked method simulating a mouse click event
				additionalProps.onKeyDown = function (e) {
					return e.which === 32 && _this2.onItemClicked(eventKey, e);
				};
				additionalProps.onKeyDown = function (e) {
					return e.which === 9 && _this2.handleRootClose();
				};
				return _react2.default.cloneElement(item, _extends({}, additionalProps));
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var _props2 = this.props,
			    multiple = _props2.multiple,
			    props = _objectWithoutProperties(_props2, ['multiple']);
			// Remove custom added props to prevent them propagate through the underlying components


			delete props.selectedItems;
			delete props.intl;
			delete props.title;
			return _react2.default.createElement(
				_RootCloseWrapper2.default,
				{
					onRootClose: this.handleRootClose
				},
				_react2.default.createElement(
					_reactBootstrap.Dropdown,
					_extends({}, props, {
						open: this.state.open,
						onSelect: this.onItemClicked,
						onToggle: function onToggle() {},
						onKeyDown: function onKeyDown(e) {
							e.which === 9 && _this3.handleRootClose();
						},
						vertical: true
					}),
					_react2.default.createElement(
						_reactBootstrap.Dropdown.Toggle,
						{ onClick: this.toggle, block: true },
						this.getButtonText()
					),
					_react2.default.createElement(
						_reactBootstrap.Dropdown.Menu,
						{ className: (0, _classnames2.default)({ multiple: multiple }) },
						this.renderItems()
					)
				)
			);
		}
	}]);

	return DropdownButton;
}(_react2.default.Component);

/* supports all the properties of the react-bootstrap's DropdownButton component (except noCaret)
		(https://react-bootstrap.github.io/components.html#btn-dropdowns-props-dropdown-button)
		and few more listed below. To be used just like the react-bootstrap with MenuItems*/


DropdownButton.propTypes = {
	/* An html id attribute, necessary for assistive technologies, such as screen readers. */
	id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,

	/* renders checkboxes with the menu items enabling user to select multiple */
	multiple: _propTypes2.default.bool,

	/* called each time the selection is modified returning the following:
 	 1. eventKey of the clicked item
 	 2. event object
 	 3. an array of eventKeys of the selected items */
	onSelect: _propTypes2.default.func,

	/* an array of the eventKeys of the items (pre)selected */
	selectedItems: _propTypes2.default.array,

	/* title to be displayed on the dropdown button. The usecases are:
 	 1. If using the component w/ a label, you should leave the title undefined. It will have a
 			a default text and will display selected items if there is any.
 	 2. If using the component w/o a label, you should provide the title which will be kept on
 	 		the component so that it doesn't lose its context. Number of selected items is shown
 			in brackets
 	 3. If you need to custom format the component's content, provide a formatter function. It
 	 		looks like this: (selectedItems) => { return <some html or text> } */
	title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
};

DropdownButton.defaultProps = {
	multiple: false,
	selectedItems: []
};

DropdownButton.MenuItem = _reactBootstrap.MenuItem;

var _default = (0, _reactIntl.injectIntl)(DropdownButton);

exports.default = _default;
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(DropdownButton, 'DropdownButton', 'src/components/DropdownButton.jsx');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/DropdownButton.jsx');
}();

;